import { AxiosResponse } from 'axios';
import { IndividualMovements } from '../../../Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/IndividualMovements';
import { MonitoringAndEvaluationDto } from '../../../Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/MonitoringAndEvaluation';
import { SkillsDevelopmentIndividual } from '../../../Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/SkillsDevelopment';
import { WorkforceProfileDto} from '../../../Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/WorkforceProfile';
import { axiosCoreInstance } from '../../AxiosCoreInterceptor';
import * as ApiUrls from './ApiUrl.EEA2';

export const EEA2Service = {
    GetEmployeeMovementHeadcountSummary: (scorecardId:string ): Promise<AxiosResponse<WorkforceProfileDto.EmployeeMovements>> => 
        axiosCoreInstance.get(`${ApiUrls.GetEmployeeMovementHeadcountSummary}?ScorecardId=${scorecardId}`),

    GetIndividualMovements: (searchRequest: IndividualMovements.Request): Promise<AxiosResponse<IndividualMovements.Response>> => 
        axiosCoreInstance.post(ApiUrls.GetIndividualEmployeeMovementInfo, searchRequest),

    GetSkillsDevelopmentIndividuals: (searchRequest: SkillsDevelopmentIndividual.Request): Promise<AxiosResponse<SkillsDevelopmentIndividual.Response>> => 
        axiosCoreInstance.post(ApiUrls.GetSkillsDevelopmentIndividualsInfo, searchRequest),

    GetSkillsDevelopmentHeadcountSummary: (scorecardId: string): Promise<AxiosResponse<WorkforceProfileDto.SummarySectionDto[]>> => 
        axiosCoreInstance.get(`${ApiUrls.GetSkillsDevelopmentHeadcountSummary}?ScorecardId=${scorecardId}`),
    
    GetWorkforceProfileHeadcountSummary: (parameters: WorkforceProfileDto.SummarySearchParameters ): Promise<AxiosResponse<WorkforceProfileDto.SummarySectionDto[]>> => 
        axiosCoreInstance.get(ApiUrls.GetWorkforceProfileHeacountSummary, {params: parameters}),
    
    GetMonitoringAndEvaluationInfo: (scorecardId: string): Promise<AxiosResponse<MonitoringAndEvaluationDto.Dto>> => 
        axiosCoreInstance.get(`${ApiUrls.GetMonitoringAndEvaluationInfo}?ScorecardId=${scorecardId}`),
    
    SaveMonitoringAndEvaluationInfo: (request : MonitoringAndEvaluationDto.Dto) :Promise<AxiosResponse<MonitoringAndEvaluationDto.Dto>> => 
        axiosCoreInstance.post(ApiUrls.SaveMonitoringAndEvaluationInfo, request)

}